export const messages = {
  title: {
    id: 'admin/promotions.form.regular.title',
  },
  validation: {
    generic: {
      id: 'admin/promotions.form.group-box.validation.generic',
    },
    emptyScope: { id: 'admin/promotions.form.validation.trigger.empty' },
    emptyBenefit: { id: 'admin/promotions.form.validation.benefit.empty' },
  },
}
